import { render } from "./StaffDataServer.vue?vue&type=template&id=0d507f14"
import script from "./StaffDataServer.vue?vue&type=script&lang=js"
export * from "./StaffDataServer.vue?vue&type=script&lang=js"
script.render = render

export default script